
export default () => ({
	meta: {},
	parts: null,
	picturesCallback: null,
	selectedParts: [],
	params: {
		manufacturers: []
	},
	tpParamsByDepartment: {},
	partWheelSpecifications: null,
	wheelSpecifications: null,
	partsStatistics: null,
	partParams: {},
	showing: 'department',
	manufacturerModels: [],
	modelModifications: [],
	modificationEngines: [],
	departmentLocations: [],
	currentPart: {},
	logs: [],
	searchFilters: {},
	loading: {
		meta: false,
		parts: false,
		logs: false,
		part: false,
		params: false,
		partParent: false,
		wheelSpecifications: false,
		tasks: false
	}
})
